// extracted by mini-css-extract-plugin
export default {"container":"BIFgj1Whg_b6cBTnrVbY"};